// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2WU04","productName":"Table_productName__1oNl6"};